// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: identity.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Params } from "./common";
import { TradingAccount_TradingAccountParameter } from "./trading-bridge";

export const protobufPackage = "com.tick2trade.api.identity";

export enum AuthProvider {
  AUTH_PROVIDER_UNKNOWN = 0,
  GOOGLE = 1,
  X = 2,
  UPSTOX = 3,
  ZERODHA = 4,
  PASSWORD = 5,
  ANGEL_ONE = 6,
  FYERS = 7,
  UNRECOGNIZED = -1,
}

export function authProviderFromJSON(object: any): AuthProvider {
  switch (object) {
    case 0:
    case "AUTH_PROVIDER_UNKNOWN":
      return AuthProvider.AUTH_PROVIDER_UNKNOWN;
    case 1:
    case "GOOGLE":
      return AuthProvider.GOOGLE;
    case 2:
    case "X":
      return AuthProvider.X;
    case 3:
    case "UPSTOX":
      return AuthProvider.UPSTOX;
    case 4:
    case "ZERODHA":
      return AuthProvider.ZERODHA;
    case 5:
    case "PASSWORD":
      return AuthProvider.PASSWORD;
    case 6:
    case "ANGEL_ONE":
      return AuthProvider.ANGEL_ONE;
    case 7:
    case "FYERS":
      return AuthProvider.FYERS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthProvider.UNRECOGNIZED;
  }
}

export function authProviderToJSON(object: AuthProvider): string {
  switch (object) {
    case AuthProvider.AUTH_PROVIDER_UNKNOWN:
      return "AUTH_PROVIDER_UNKNOWN";
    case AuthProvider.GOOGLE:
      return "GOOGLE";
    case AuthProvider.X:
      return "X";
    case AuthProvider.UPSTOX:
      return "UPSTOX";
    case AuthProvider.ZERODHA:
      return "ZERODHA";
    case AuthProvider.PASSWORD:
      return "PASSWORD";
    case AuthProvider.ANGEL_ONE:
      return "ANGEL_ONE";
    case AuthProvider.FYERS:
      return "FYERS";
    case AuthProvider.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AuthProviderType {
  AUTH_PROVIDER_TYPE_UNKNOWN = 0,
  EMAIL_PROVIDER = 1,
  BROKER = 2,
  UNRECOGNIZED = -1,
}

export function authProviderTypeFromJSON(object: any): AuthProviderType {
  switch (object) {
    case 0:
    case "AUTH_PROVIDER_TYPE_UNKNOWN":
      return AuthProviderType.AUTH_PROVIDER_TYPE_UNKNOWN;
    case 1:
    case "EMAIL_PROVIDER":
      return AuthProviderType.EMAIL_PROVIDER;
    case 2:
    case "BROKER":
      return AuthProviderType.BROKER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthProviderType.UNRECOGNIZED;
  }
}

export function authProviderTypeToJSON(object: AuthProviderType): string {
  switch (object) {
    case AuthProviderType.AUTH_PROVIDER_TYPE_UNKNOWN:
      return "AUTH_PROVIDER_TYPE_UNKNOWN";
    case AuthProviderType.EMAIL_PROVIDER:
      return "EMAIL_PROVIDER";
    case AuthProviderType.BROKER:
      return "BROKER";
    case AuthProviderType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Role {
  ADMIN = 0,
  USER = 1,
  UNRECOGNIZED = -1,
}

export function roleFromJSON(object: any): Role {
  switch (object) {
    case 0:
    case "ADMIN":
      return Role.ADMIN;
    case 1:
    case "USER":
      return Role.USER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Role.UNRECOGNIZED;
  }
}

export function roleToJSON(object: Role): string {
  switch (object) {
    case Role.ADMIN:
      return "ADMIN";
    case Role.USER:
      return "USER";
    case Role.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface User {
  id: string;
  email: string;
  name: string;
  avatarUrl: string;
  provider: AuthProvider;
  providerUserId: string;
  status: User_Status;
  countryCode: string;
  mobile: string;
  mobileVerified: boolean;
  attributes: string;
  preferences: string;
  authorities: string[];
  subscriptionPlans: string[];
}

export enum User_Status {
  STATUS_UNKNOWN = 0,
  ACTIVE = 1,
  WAIT_LISTED = 2,
  BLOCKED = 3,
  UNRECOGNIZED = -1,
}

export function user_StatusFromJSON(object: any): User_Status {
  switch (object) {
    case 0:
    case "STATUS_UNKNOWN":
      return User_Status.STATUS_UNKNOWN;
    case 1:
    case "ACTIVE":
      return User_Status.ACTIVE;
    case 2:
    case "WAIT_LISTED":
      return User_Status.WAIT_LISTED;
    case 3:
    case "BLOCKED":
      return User_Status.BLOCKED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return User_Status.UNRECOGNIZED;
  }
}

export function user_StatusToJSON(object: User_Status): string {
  switch (object) {
    case User_Status.STATUS_UNKNOWN:
      return "STATUS_UNKNOWN";
    case User_Status.ACTIVE:
      return "ACTIVE";
    case User_Status.WAIT_LISTED:
      return "WAIT_LISTED";
    case User_Status.BLOCKED:
      return "BLOCKED";
    case User_Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Users {
  users: User[];
}

export interface ThirdPartyLoginProvider {
  code: string;
  redirectUrl: string;
  validateUrl: string;
  type: ThirdPartyLoginProvider_Type;
}

export enum ThirdPartyLoginProvider_Type {
  LOGIN_PROVIDER_UNKNOWN = 0,
  EMAIL_PROVIDER = 1,
  BROKER = 2,
  UNRECOGNIZED = -1,
}

export function thirdPartyLoginProvider_TypeFromJSON(object: any): ThirdPartyLoginProvider_Type {
  switch (object) {
    case 0:
    case "LOGIN_PROVIDER_UNKNOWN":
      return ThirdPartyLoginProvider_Type.LOGIN_PROVIDER_UNKNOWN;
    case 1:
    case "EMAIL_PROVIDER":
      return ThirdPartyLoginProvider_Type.EMAIL_PROVIDER;
    case 2:
    case "BROKER":
      return ThirdPartyLoginProvider_Type.BROKER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ThirdPartyLoginProvider_Type.UNRECOGNIZED;
  }
}

export function thirdPartyLoginProvider_TypeToJSON(object: ThirdPartyLoginProvider_Type): string {
  switch (object) {
    case ThirdPartyLoginProvider_Type.LOGIN_PROVIDER_UNKNOWN:
      return "LOGIN_PROVIDER_UNKNOWN";
    case ThirdPartyLoginProvider_Type.EMAIL_PROVIDER:
      return "EMAIL_PROVIDER";
    case ThirdPartyLoginProvider_Type.BROKER:
      return "BROKER";
    case ThirdPartyLoginProvider_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ValidateTokenResponse {
  user: User | undefined;
  tradingAccount: ValidateTokenResponse_TradingAccount | undefined;
}

export interface ValidateTokenResponse_TradingAccount {
  brokerCode: string;
  brokerUserId: string;
  exchanges: string[];
  products: string[];
  orderTypes: string[];
  tradingAccountParameters: TradingAccount_TradingAccountParameter[];
}

export interface AuthProviderLoginUrlRequest {
  authProvider: AuthProvider;
  params: Params[];
}

export interface AuthProviderLoginUrlResponse {
  authProvider: AuthProvider;
  url: string;
  redirectParamsKey: string;
}

export interface ValidateThirdPartyTokenRequest {
  authProvider: AuthProvider;
  tokenInfo: ValidateThirdPartyTokenRequest_TokenInfo[];
}

export interface ValidateThirdPartyTokenRequest_TokenInfo {
  key: string;
  value: string;
}

export interface AddMobileNumberRequest {
  countryCode: string;
  mobileNumber: string;
}

export interface AddMobileNumberResponse {
  verificationRequired: boolean;
  user: User | undefined;
  requestId: string;
}

export interface ResendVerificationCodeResponse {
  requestId: string;
}

export interface VerifyMobileNumberRequest {
  verificationCode: string;
  requestId: string;
}

export interface VerifyMobileNumberResponse {
  successful: boolean;
  user: User | undefined;
}

export interface UserSignUpRequest {
  name: string;
  email: string;
  password: string;
  emailVerificationRequestId: string;
  emailVerificationOtp: string;
}

export interface ForgetPasswordRequest {
  email: string;
  newPassword: string;
  emailVerificationRequestId: string;
  emailVerificationOtp: string;
}

export interface SendEmailOtpResponse {
  requestId: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  tokenType: string;
  isNewUser?: boolean | undefined;
}

function createBaseUser(): User {
  return {
    id: "",
    email: "",
    name: "",
    avatarUrl: "",
    provider: 0,
    providerUserId: "",
    status: 0,
    countryCode: "",
    mobile: "",
    mobileVerified: false,
    attributes: "",
    preferences: "",
    authorities: [],
    subscriptionPlans: [],
  };
}

export const User = {
  encode(message: User, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.avatarUrl !== "") {
      writer.uint32(50).string(message.avatarUrl);
    }
    if (message.provider !== 0) {
      writer.uint32(64).int32(message.provider);
    }
    if (message.providerUserId !== "") {
      writer.uint32(82).string(message.providerUserId);
    }
    if (message.status !== 0) {
      writer.uint32(96).int32(message.status);
    }
    if (message.countryCode !== "") {
      writer.uint32(106).string(message.countryCode);
    }
    if (message.mobile !== "") {
      writer.uint32(114).string(message.mobile);
    }
    if (message.mobileVerified !== false) {
      writer.uint32(128).bool(message.mobileVerified);
    }
    if (message.attributes !== "") {
      writer.uint32(146).string(message.attributes);
    }
    if (message.preferences !== "") {
      writer.uint32(162).string(message.preferences);
    }
    for (const v of message.authorities) {
      writer.uint32(170).string(v!);
    }
    for (const v of message.subscriptionPlans) {
      writer.uint32(186).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): User {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.avatarUrl = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.providerUserId = reader.string();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.countryCode = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.mobile = reader.string();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.mobileVerified = reader.bool();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.attributes = reader.string();
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.preferences = reader.string();
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.authorities.push(reader.string());
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.subscriptionPlans.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): User {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      avatarUrl: isSet(object.avatarUrl) ? globalThis.String(object.avatarUrl) : "",
      provider: isSet(object.provider) ? authProviderFromJSON(object.provider) : 0,
      providerUserId: isSet(object.providerUserId) ? globalThis.String(object.providerUserId) : "",
      status: isSet(object.status) ? user_StatusFromJSON(object.status) : 0,
      countryCode: isSet(object.countryCode) ? globalThis.String(object.countryCode) : "",
      mobile: isSet(object.mobile) ? globalThis.String(object.mobile) : "",
      mobileVerified: isSet(object.mobileVerified) ? globalThis.Boolean(object.mobileVerified) : false,
      attributes: isSet(object.attributes) ? globalThis.String(object.attributes) : "",
      preferences: isSet(object.preferences) ? globalThis.String(object.preferences) : "",
      authorities: globalThis.Array.isArray(object?.authorities)
        ? object.authorities.map((e: any) => globalThis.String(e))
        : [],
      subscriptionPlans: globalThis.Array.isArray(object?.subscriptionPlans)
        ? object.subscriptionPlans.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: User): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.avatarUrl !== "") {
      obj.avatarUrl = message.avatarUrl;
    }
    if (message.provider !== 0) {
      obj.provider = authProviderToJSON(message.provider);
    }
    if (message.providerUserId !== "") {
      obj.providerUserId = message.providerUserId;
    }
    if (message.status !== 0) {
      obj.status = user_StatusToJSON(message.status);
    }
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.mobile !== "") {
      obj.mobile = message.mobile;
    }
    if (message.mobileVerified !== false) {
      obj.mobileVerified = message.mobileVerified;
    }
    if (message.attributes !== "") {
      obj.attributes = message.attributes;
    }
    if (message.preferences !== "") {
      obj.preferences = message.preferences;
    }
    if (message.authorities?.length) {
      obj.authorities = message.authorities;
    }
    if (message.subscriptionPlans?.length) {
      obj.subscriptionPlans = message.subscriptionPlans;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<User>, I>>(base?: I): User {
    return User.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<User>, I>>(object: I): User {
    const message = createBaseUser();
    message.id = object.id ?? "";
    message.email = object.email ?? "";
    message.name = object.name ?? "";
    message.avatarUrl = object.avatarUrl ?? "";
    message.provider = object.provider ?? 0;
    message.providerUserId = object.providerUserId ?? "";
    message.status = object.status ?? 0;
    message.countryCode = object.countryCode ?? "";
    message.mobile = object.mobile ?? "";
    message.mobileVerified = object.mobileVerified ?? false;
    message.attributes = object.attributes ?? "";
    message.preferences = object.preferences ?? "";
    message.authorities = object.authorities?.map((e) => e) || [];
    message.subscriptionPlans = object.subscriptionPlans?.map((e) => e) || [];
    return message;
  },
};

function createBaseUsers(): Users {
  return { users: [] };
}

export const Users = {
  encode(message: Users, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.users) {
      User.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Users {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.users.push(User.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Users {
    return { users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => User.fromJSON(e)) : [] };
  },

  toJSON(message: Users): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => User.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Users>, I>>(base?: I): Users {
    return Users.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Users>, I>>(object: I): Users {
    const message = createBaseUsers();
    message.users = object.users?.map((e) => User.fromPartial(e)) || [];
    return message;
  },
};

function createBaseThirdPartyLoginProvider(): ThirdPartyLoginProvider {
  return { code: "", redirectUrl: "", validateUrl: "", type: 0 };
}

export const ThirdPartyLoginProvider = {
  encode(message: ThirdPartyLoginProvider, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.redirectUrl !== "") {
      writer.uint32(18).string(message.redirectUrl);
    }
    if (message.validateUrl !== "") {
      writer.uint32(26).string(message.validateUrl);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ThirdPartyLoginProvider {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThirdPartyLoginProvider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.redirectUrl = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.validateUrl = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThirdPartyLoginProvider {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      redirectUrl: isSet(object.redirectUrl) ? globalThis.String(object.redirectUrl) : "",
      validateUrl: isSet(object.validateUrl) ? globalThis.String(object.validateUrl) : "",
      type: isSet(object.type) ? thirdPartyLoginProvider_TypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: ThirdPartyLoginProvider): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.redirectUrl !== "") {
      obj.redirectUrl = message.redirectUrl;
    }
    if (message.validateUrl !== "") {
      obj.validateUrl = message.validateUrl;
    }
    if (message.type !== 0) {
      obj.type = thirdPartyLoginProvider_TypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ThirdPartyLoginProvider>, I>>(base?: I): ThirdPartyLoginProvider {
    return ThirdPartyLoginProvider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ThirdPartyLoginProvider>, I>>(object: I): ThirdPartyLoginProvider {
    const message = createBaseThirdPartyLoginProvider();
    message.code = object.code ?? "";
    message.redirectUrl = object.redirectUrl ?? "";
    message.validateUrl = object.validateUrl ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseValidateTokenResponse(): ValidateTokenResponse {
  return { user: undefined, tradingAccount: undefined };
}

export const ValidateTokenResponse = {
  encode(message: ValidateTokenResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    if (message.tradingAccount !== undefined) {
      ValidateTokenResponse_TradingAccount.encode(message.tradingAccount, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidateTokenResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateTokenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.tradingAccount = ValidateTokenResponse_TradingAccount.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateTokenResponse {
    return {
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      tradingAccount: isSet(object.tradingAccount)
        ? ValidateTokenResponse_TradingAccount.fromJSON(object.tradingAccount)
        : undefined,
    };
  },

  toJSON(message: ValidateTokenResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.tradingAccount !== undefined) {
      obj.tradingAccount = ValidateTokenResponse_TradingAccount.toJSON(message.tradingAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateTokenResponse>, I>>(base?: I): ValidateTokenResponse {
    return ValidateTokenResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateTokenResponse>, I>>(object: I): ValidateTokenResponse {
    const message = createBaseValidateTokenResponse();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.tradingAccount = (object.tradingAccount !== undefined && object.tradingAccount !== null)
      ? ValidateTokenResponse_TradingAccount.fromPartial(object.tradingAccount)
      : undefined;
    return message;
  },
};

function createBaseValidateTokenResponse_TradingAccount(): ValidateTokenResponse_TradingAccount {
  return {
    brokerCode: "",
    brokerUserId: "",
    exchanges: [],
    products: [],
    orderTypes: [],
    tradingAccountParameters: [],
  };
}

export const ValidateTokenResponse_TradingAccount = {
  encode(message: ValidateTokenResponse_TradingAccount, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.brokerCode !== "") {
      writer.uint32(18).string(message.brokerCode);
    }
    if (message.brokerUserId !== "") {
      writer.uint32(34).string(message.brokerUserId);
    }
    for (const v of message.exchanges) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.products) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.orderTypes) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.tradingAccountParameters) {
      TradingAccount_TradingAccountParameter.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidateTokenResponse_TradingAccount {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateTokenResponse_TradingAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.brokerUserId = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.exchanges.push(reader.string());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.products.push(reader.string());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.orderTypes.push(reader.string());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.tradingAccountParameters.push(TradingAccount_TradingAccountParameter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateTokenResponse_TradingAccount {
    return {
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      brokerUserId: isSet(object.brokerUserId) ? globalThis.String(object.brokerUserId) : "",
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => globalThis.String(e))
        : [],
      products: globalThis.Array.isArray(object?.products) ? object.products.map((e: any) => globalThis.String(e)) : [],
      orderTypes: globalThis.Array.isArray(object?.orderTypes)
        ? object.orderTypes.map((e: any) => globalThis.String(e))
        : [],
      tradingAccountParameters: globalThis.Array.isArray(object?.tradingAccountParameters)
        ? object.tradingAccountParameters.map((e: any) => TradingAccount_TradingAccountParameter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ValidateTokenResponse_TradingAccount): unknown {
    const obj: any = {};
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.brokerUserId !== "") {
      obj.brokerUserId = message.brokerUserId;
    }
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges;
    }
    if (message.products?.length) {
      obj.products = message.products;
    }
    if (message.orderTypes?.length) {
      obj.orderTypes = message.orderTypes;
    }
    if (message.tradingAccountParameters?.length) {
      obj.tradingAccountParameters = message.tradingAccountParameters.map((e) =>
        TradingAccount_TradingAccountParameter.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateTokenResponse_TradingAccount>, I>>(
    base?: I,
  ): ValidateTokenResponse_TradingAccount {
    return ValidateTokenResponse_TradingAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateTokenResponse_TradingAccount>, I>>(
    object: I,
  ): ValidateTokenResponse_TradingAccount {
    const message = createBaseValidateTokenResponse_TradingAccount();
    message.brokerCode = object.brokerCode ?? "";
    message.brokerUserId = object.brokerUserId ?? "";
    message.exchanges = object.exchanges?.map((e) => e) || [];
    message.products = object.products?.map((e) => e) || [];
    message.orderTypes = object.orderTypes?.map((e) => e) || [];
    message.tradingAccountParameters =
      object.tradingAccountParameters?.map((e) => TradingAccount_TradingAccountParameter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAuthProviderLoginUrlRequest(): AuthProviderLoginUrlRequest {
  return { authProvider: 0, params: [] };
}

export const AuthProviderLoginUrlRequest = {
  encode(message: AuthProviderLoginUrlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authProvider !== 0) {
      writer.uint32(8).int32(message.authProvider);
    }
    for (const v of message.params) {
      Params.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AuthProviderLoginUrlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthProviderLoginUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.authProvider = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.params.push(Params.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AuthProviderLoginUrlRequest {
    return {
      authProvider: isSet(object.authProvider) ? authProviderFromJSON(object.authProvider) : 0,
      params: globalThis.Array.isArray(object?.params) ? object.params.map((e: any) => Params.fromJSON(e)) : [],
    };
  },

  toJSON(message: AuthProviderLoginUrlRequest): unknown {
    const obj: any = {};
    if (message.authProvider !== 0) {
      obj.authProvider = authProviderToJSON(message.authProvider);
    }
    if (message.params?.length) {
      obj.params = message.params.map((e) => Params.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AuthProviderLoginUrlRequest>, I>>(base?: I): AuthProviderLoginUrlRequest {
    return AuthProviderLoginUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AuthProviderLoginUrlRequest>, I>>(object: I): AuthProviderLoginUrlRequest {
    const message = createBaseAuthProviderLoginUrlRequest();
    message.authProvider = object.authProvider ?? 0;
    message.params = object.params?.map((e) => Params.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAuthProviderLoginUrlResponse(): AuthProviderLoginUrlResponse {
  return { authProvider: 0, url: "", redirectParamsKey: "" };
}

export const AuthProviderLoginUrlResponse = {
  encode(message: AuthProviderLoginUrlResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authProvider !== 0) {
      writer.uint32(8).int32(message.authProvider);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.redirectParamsKey !== "") {
      writer.uint32(26).string(message.redirectParamsKey);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AuthProviderLoginUrlResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthProviderLoginUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.authProvider = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.redirectParamsKey = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AuthProviderLoginUrlResponse {
    return {
      authProvider: isSet(object.authProvider) ? authProviderFromJSON(object.authProvider) : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      redirectParamsKey: isSet(object.redirectParamsKey) ? globalThis.String(object.redirectParamsKey) : "",
    };
  },

  toJSON(message: AuthProviderLoginUrlResponse): unknown {
    const obj: any = {};
    if (message.authProvider !== 0) {
      obj.authProvider = authProviderToJSON(message.authProvider);
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.redirectParamsKey !== "") {
      obj.redirectParamsKey = message.redirectParamsKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AuthProviderLoginUrlResponse>, I>>(base?: I): AuthProviderLoginUrlResponse {
    return AuthProviderLoginUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AuthProviderLoginUrlResponse>, I>>(object: I): AuthProviderLoginUrlResponse {
    const message = createBaseAuthProviderLoginUrlResponse();
    message.authProvider = object.authProvider ?? 0;
    message.url = object.url ?? "";
    message.redirectParamsKey = object.redirectParamsKey ?? "";
    return message;
  },
};

function createBaseValidateThirdPartyTokenRequest(): ValidateThirdPartyTokenRequest {
  return { authProvider: 0, tokenInfo: [] };
}

export const ValidateThirdPartyTokenRequest = {
  encode(message: ValidateThirdPartyTokenRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authProvider !== 0) {
      writer.uint32(16).int32(message.authProvider);
    }
    for (const v of message.tokenInfo) {
      ValidateThirdPartyTokenRequest_TokenInfo.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidateThirdPartyTokenRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateThirdPartyTokenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.authProvider = reader.int32() as any;
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tokenInfo.push(ValidateThirdPartyTokenRequest_TokenInfo.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateThirdPartyTokenRequest {
    return {
      authProvider: isSet(object.authProvider) ? authProviderFromJSON(object.authProvider) : 0,
      tokenInfo: globalThis.Array.isArray(object?.tokenInfo)
        ? object.tokenInfo.map((e: any) => ValidateThirdPartyTokenRequest_TokenInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ValidateThirdPartyTokenRequest): unknown {
    const obj: any = {};
    if (message.authProvider !== 0) {
      obj.authProvider = authProviderToJSON(message.authProvider);
    }
    if (message.tokenInfo?.length) {
      obj.tokenInfo = message.tokenInfo.map((e) => ValidateThirdPartyTokenRequest_TokenInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest>, I>>(base?: I): ValidateThirdPartyTokenRequest {
    return ValidateThirdPartyTokenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest>, I>>(
    object: I,
  ): ValidateThirdPartyTokenRequest {
    const message = createBaseValidateThirdPartyTokenRequest();
    message.authProvider = object.authProvider ?? 0;
    message.tokenInfo = object.tokenInfo?.map((e) => ValidateThirdPartyTokenRequest_TokenInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseValidateThirdPartyTokenRequest_TokenInfo(): ValidateThirdPartyTokenRequest_TokenInfo {
  return { key: "", value: "" };
}

export const ValidateThirdPartyTokenRequest_TokenInfo = {
  encode(message: ValidateThirdPartyTokenRequest_TokenInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidateThirdPartyTokenRequest_TokenInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateThirdPartyTokenRequest_TokenInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateThirdPartyTokenRequest_TokenInfo {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ValidateThirdPartyTokenRequest_TokenInfo): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest_TokenInfo>, I>>(
    base?: I,
  ): ValidateThirdPartyTokenRequest_TokenInfo {
    return ValidateThirdPartyTokenRequest_TokenInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest_TokenInfo>, I>>(
    object: I,
  ): ValidateThirdPartyTokenRequest_TokenInfo {
    const message = createBaseValidateThirdPartyTokenRequest_TokenInfo();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseAddMobileNumberRequest(): AddMobileNumberRequest {
  return { countryCode: "", mobileNumber: "" };
}

export const AddMobileNumberRequest = {
  encode(message: AddMobileNumberRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.countryCode !== "") {
      writer.uint32(10).string(message.countryCode);
    }
    if (message.mobileNumber !== "") {
      writer.uint32(18).string(message.mobileNumber);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddMobileNumberRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMobileNumberRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.countryCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.mobileNumber = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMobileNumberRequest {
    return {
      countryCode: isSet(object.countryCode) ? globalThis.String(object.countryCode) : "",
      mobileNumber: isSet(object.mobileNumber) ? globalThis.String(object.mobileNumber) : "",
    };
  },

  toJSON(message: AddMobileNumberRequest): unknown {
    const obj: any = {};
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.mobileNumber !== "") {
      obj.mobileNumber = message.mobileNumber;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMobileNumberRequest>, I>>(base?: I): AddMobileNumberRequest {
    return AddMobileNumberRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMobileNumberRequest>, I>>(object: I): AddMobileNumberRequest {
    const message = createBaseAddMobileNumberRequest();
    message.countryCode = object.countryCode ?? "";
    message.mobileNumber = object.mobileNumber ?? "";
    return message;
  },
};

function createBaseAddMobileNumberResponse(): AddMobileNumberResponse {
  return { verificationRequired: false, user: undefined, requestId: "" };
}

export const AddMobileNumberResponse = {
  encode(message: AddMobileNumberResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.verificationRequired !== false) {
      writer.uint32(8).bool(message.verificationRequired);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    if (message.requestId !== "") {
      writer.uint32(26).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddMobileNumberResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMobileNumberResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.verificationRequired = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMobileNumberResponse {
    return {
      verificationRequired: isSet(object.verificationRequired)
        ? globalThis.Boolean(object.verificationRequired)
        : false,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
    };
  },

  toJSON(message: AddMobileNumberResponse): unknown {
    const obj: any = {};
    if (message.verificationRequired !== false) {
      obj.verificationRequired = message.verificationRequired;
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMobileNumberResponse>, I>>(base?: I): AddMobileNumberResponse {
    return AddMobileNumberResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMobileNumberResponse>, I>>(object: I): AddMobileNumberResponse {
    const message = createBaseAddMobileNumberResponse();
    message.verificationRequired = object.verificationRequired ?? false;
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseResendVerificationCodeResponse(): ResendVerificationCodeResponse {
  return { requestId: "" };
}

export const ResendVerificationCodeResponse = {
  encode(message: ResendVerificationCodeResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResendVerificationCodeResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResendVerificationCodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResendVerificationCodeResponse {
    return { requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "" };
  },

  toJSON(message: ResendVerificationCodeResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResendVerificationCodeResponse>, I>>(base?: I): ResendVerificationCodeResponse {
    return ResendVerificationCodeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResendVerificationCodeResponse>, I>>(
    object: I,
  ): ResendVerificationCodeResponse {
    const message = createBaseResendVerificationCodeResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseVerifyMobileNumberRequest(): VerifyMobileNumberRequest {
  return { verificationCode: "", requestId: "" };
}

export const VerifyMobileNumberRequest = {
  encode(message: VerifyMobileNumberRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.verificationCode !== "") {
      writer.uint32(10).string(message.verificationCode);
    }
    if (message.requestId !== "") {
      writer.uint32(18).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyMobileNumberRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyMobileNumberRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.verificationCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyMobileNumberRequest {
    return {
      verificationCode: isSet(object.verificationCode) ? globalThis.String(object.verificationCode) : "",
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
    };
  },

  toJSON(message: VerifyMobileNumberRequest): unknown {
    const obj: any = {};
    if (message.verificationCode !== "") {
      obj.verificationCode = message.verificationCode;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyMobileNumberRequest>, I>>(base?: I): VerifyMobileNumberRequest {
    return VerifyMobileNumberRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyMobileNumberRequest>, I>>(object: I): VerifyMobileNumberRequest {
    const message = createBaseVerifyMobileNumberRequest();
    message.verificationCode = object.verificationCode ?? "";
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseVerifyMobileNumberResponse(): VerifyMobileNumberResponse {
  return { successful: false, user: undefined };
}

export const VerifyMobileNumberResponse = {
  encode(message: VerifyMobileNumberResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.successful !== false) {
      writer.uint32(8).bool(message.successful);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyMobileNumberResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyMobileNumberResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.successful = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyMobileNumberResponse {
    return {
      successful: isSet(object.successful) ? globalThis.Boolean(object.successful) : false,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: VerifyMobileNumberResponse): unknown {
    const obj: any = {};
    if (message.successful !== false) {
      obj.successful = message.successful;
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyMobileNumberResponse>, I>>(base?: I): VerifyMobileNumberResponse {
    return VerifyMobileNumberResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyMobileNumberResponse>, I>>(object: I): VerifyMobileNumberResponse {
    const message = createBaseVerifyMobileNumberResponse();
    message.successful = object.successful ?? false;
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseUserSignUpRequest(): UserSignUpRequest {
  return { name: "", email: "", password: "", emailVerificationRequestId: "", emailVerificationOtp: "" };
}

export const UserSignUpRequest = {
  encode(message: UserSignUpRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    if (message.emailVerificationRequestId !== "") {
      writer.uint32(34).string(message.emailVerificationRequestId);
    }
    if (message.emailVerificationOtp !== "") {
      writer.uint32(42).string(message.emailVerificationOtp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSignUpRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSignUpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.emailVerificationRequestId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.emailVerificationOtp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSignUpRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      emailVerificationRequestId: isSet(object.emailVerificationRequestId)
        ? globalThis.String(object.emailVerificationRequestId)
        : "",
      emailVerificationOtp: isSet(object.emailVerificationOtp) ? globalThis.String(object.emailVerificationOtp) : "",
    };
  },

  toJSON(message: UserSignUpRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.emailVerificationRequestId !== "") {
      obj.emailVerificationRequestId = message.emailVerificationRequestId;
    }
    if (message.emailVerificationOtp !== "") {
      obj.emailVerificationOtp = message.emailVerificationOtp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSignUpRequest>, I>>(base?: I): UserSignUpRequest {
    return UserSignUpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSignUpRequest>, I>>(object: I): UserSignUpRequest {
    const message = createBaseUserSignUpRequest();
    message.name = object.name ?? "";
    message.email = object.email ?? "";
    message.password = object.password ?? "";
    message.emailVerificationRequestId = object.emailVerificationRequestId ?? "";
    message.emailVerificationOtp = object.emailVerificationOtp ?? "";
    return message;
  },
};

function createBaseForgetPasswordRequest(): ForgetPasswordRequest {
  return { email: "", newPassword: "", emailVerificationRequestId: "", emailVerificationOtp: "" };
}

export const ForgetPasswordRequest = {
  encode(message: ForgetPasswordRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.newPassword !== "") {
      writer.uint32(18).string(message.newPassword);
    }
    if (message.emailVerificationRequestId !== "") {
      writer.uint32(26).string(message.emailVerificationRequestId);
    }
    if (message.emailVerificationOtp !== "") {
      writer.uint32(34).string(message.emailVerificationOtp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ForgetPasswordRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForgetPasswordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.newPassword = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.emailVerificationRequestId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.emailVerificationOtp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ForgetPasswordRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      newPassword: isSet(object.newPassword) ? globalThis.String(object.newPassword) : "",
      emailVerificationRequestId: isSet(object.emailVerificationRequestId)
        ? globalThis.String(object.emailVerificationRequestId)
        : "",
      emailVerificationOtp: isSet(object.emailVerificationOtp) ? globalThis.String(object.emailVerificationOtp) : "",
    };
  },

  toJSON(message: ForgetPasswordRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.newPassword !== "") {
      obj.newPassword = message.newPassword;
    }
    if (message.emailVerificationRequestId !== "") {
      obj.emailVerificationRequestId = message.emailVerificationRequestId;
    }
    if (message.emailVerificationOtp !== "") {
      obj.emailVerificationOtp = message.emailVerificationOtp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ForgetPasswordRequest>, I>>(base?: I): ForgetPasswordRequest {
    return ForgetPasswordRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ForgetPasswordRequest>, I>>(object: I): ForgetPasswordRequest {
    const message = createBaseForgetPasswordRequest();
    message.email = object.email ?? "";
    message.newPassword = object.newPassword ?? "";
    message.emailVerificationRequestId = object.emailVerificationRequestId ?? "";
    message.emailVerificationOtp = object.emailVerificationOtp ?? "";
    return message;
  },
};

function createBaseSendEmailOtpResponse(): SendEmailOtpResponse {
  return { requestId: "" };
}

export const SendEmailOtpResponse = {
  encode(message: SendEmailOtpResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendEmailOtpResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendEmailOtpResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendEmailOtpResponse {
    return { requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "" };
  },

  toJSON(message: SendEmailOtpResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendEmailOtpResponse>, I>>(base?: I): SendEmailOtpResponse {
    return SendEmailOtpResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendEmailOtpResponse>, I>>(object: I): SendEmailOtpResponse {
    const message = createBaseSendEmailOtpResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseLoginRequest(): LoginRequest {
  return { email: "", password: "" };
}

export const LoginRequest = {
  encode(message: LoginRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoginRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoginRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: LoginRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoginRequest>, I>>(base?: I): LoginRequest {
    return LoginRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoginRequest>, I>>(object: I): LoginRequest {
    const message = createBaseLoginRequest();
    message.email = object.email ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseLoginResponse(): LoginResponse {
  return { accessToken: "", tokenType: "", isNewUser: undefined };
}

export const LoginResponse = {
  encode(message: LoginResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accessToken !== "") {
      writer.uint32(10).string(message.accessToken);
    }
    if (message.tokenType !== "") {
      writer.uint32(18).string(message.tokenType);
    }
    if (message.isNewUser !== undefined) {
      writer.uint32(32).bool(message.isNewUser);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoginResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accessToken = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tokenType = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isNewUser = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoginResponse {
    return {
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : "",
      tokenType: isSet(object.tokenType) ? globalThis.String(object.tokenType) : "",
      isNewUser: isSet(object.isNewUser) ? globalThis.Boolean(object.isNewUser) : undefined,
    };
  },

  toJSON(message: LoginResponse): unknown {
    const obj: any = {};
    if (message.accessToken !== "") {
      obj.accessToken = message.accessToken;
    }
    if (message.tokenType !== "") {
      obj.tokenType = message.tokenType;
    }
    if (message.isNewUser !== undefined) {
      obj.isNewUser = message.isNewUser;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoginResponse>, I>>(base?: I): LoginResponse {
    return LoginResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoginResponse>, I>>(object: I): LoginResponse {
    const message = createBaseLoginResponse();
    message.accessToken = object.accessToken ?? "";
    message.tokenType = object.tokenType ?? "";
    message.isNewUser = object.isNewUser ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
